import { createBrowserRouter } from 'react-router-dom';
import App from './App';
import { HomePage, PrivacyPolicyPage, TermsOfServicePage } from './pages';

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      {
        index: true,
        element: <HomePage />,
      },
      {
        path: 'privacy-policy',
        element: <PrivacyPolicyPage />,
      },
      {
        path: 'terms-of-service',
        element: <TermsOfServicePage />,
      }
    ],
  },
]);

export default router;